import querystring from 'querystring'
import {isString} from "validate.js"

function combineNames(prefix, name) {
  let nname = ''
  if (prefix) {
    nname = prefix + (name ? '.' : '')
  }
  return nname + (name || '')
}

function extractParameters(endpoint) {
  const regex = /:([a-z_]+)(\([^)]+\))?(\??)/ig
  const parameters = []
  let matches = regex.exec(endpoint)
  while (matches !== null) {
    parameters.push({
      expr: matches[0],
      name: matches[1],
      regex: (matches[2] ? `^${matches[2]}$` : null),
      optional: matches[3] === '?'
    })
    matches = regex.exec(endpoint)
  }
  return parameters
}

function flattenRoutes(prefix, firstSegment, reactRoutes) {
  return reactRoutes.reduce((routes, reactRoute) => {
    const name = combineNames(prefix, reactRoute.name)
    //pour l'instant on a pas de notion de sous route explicite avec l'ami react router
    const path = reactRoute.path //combineSegments(firstSegment, reactRoute.path);
    const parameters = extractParameters(path)
    let rRoutes = {}

    if (reactRoute.routes) {
      rRoutes = flattenRoutes(name, path, reactRoute.routes)
    }

    if (name) {
      rRoutes[name] = { path, name, parameters }
    }

    return {
      ...routes,
      ...rRoutes
    }
  }, {})
}

export default function makeGenerator(reactRoutes, pathPrefix = '', namePrefix = '') {
  const routes = flattenRoutes(pathPrefix, namePrefix, reactRoutes)

  return function({ name, parameters = {}, search, hash = ''}) {
    const route = routes[name]

    if (!route) {
      throw new Error(`Cannot found route names ${name}`)
    }

    let path = route.path
    for (let i = 0; i < route.parameters.length; i++) {
      const parameter = parameters[route.parameters[i].name]
      if ((parameter === undefined || parameter === null) && !route.parameters[i].optional) {
        throw new Error(`Parameter "${route.parameters[i].name}" must be defined`)
      }
      if (parameter && route.parameters[i].regex && !(new RegExp(route.parameters[i].regex, 'g')).test(parameter)) {
        throw new Error(`Invalid parameter "${route.parameters[i].name}", it must match "${route.parameters[i].regex}"`)
      }
      path = path.replace(`${route.parameters[i].expr}`, (parameter === undefined ? '' : parameter))
    }

    if (search) {
      if(isString(search)) {
        path += search
      }
      else {
        const searchParams = querystring.stringify(search)
        path += (searchParams ? '?' + searchParams : '')
      }
    }

    path += hash

    return path
  }
}
